<ng-template appShowpopup></ng-template>
<header
  *ngIf="!isPMBuddyBot"
  class="relative w-full px-6 py-3 shadow"
  [ngClass]="!isStaffingDomain ? 'bg-header_bg' : 'bg-white'"
>
  <div class="sm:flex items-center justify-between">
    <a routerLink="/main" *ngIf="loginUser?.userRole == 'CANDIDATE'">
      <img [src]="_commonServices.Images.FRACTAL_LOGO" alt="" class="w-32" />
    </a>
    <div class="flex gap-2">
      <div
        *ngIf="
          isStaffingDomain &&
          (loginUser?.userRole == 'FRACTAL_HR' ||
            loginUser?.userRole == 'VISITOR')
        "
        class="flex gap-2"
      >
        <img
          [src]="_commonServices.Images.STAFFING_MENU"
          alt=""
          class="w-5 cursor-pointer"
          alt=""
          (click)="toggleSidebar()"
        />
        <p class="my-auto text-lg poppinsMedium">Menu</p>
        <p class="absolute h-16 w-[1px] bg-gray-300 left-32 top-0"></p>
      </div>
      <img
        [src]="_commonServices.Images.FRACTAL_LOGO"
        alt=""
        class="w-32"
        *ngIf="
          loginUser?.userRole == 'FRACTAL_ADMIN' ||
          loginUser?.userRole == 'FRACTAL_HR' ||
          loginUser?.userRole == 'VISITOR' ||
          loginUser?.userRole == 'COLLEGE_ADMIN'
        "
        [ngClass]="isStaffingDomain ? 'ml-8' : ''"
      />
    </div>
    <div class="flex gap-6">
      <div
        *ngIf="loginUser?.userRole == 'FRACTAL_ADMIN'"
        (click)="navToServerHealthCheck()"
      >
        <img
          [src]="_commonServices.Images.SERVER_HEALTH"
          alt="report"
          class="cursor-pointer w-7 h-7"
        />
      </div>

      <div
        *ngIf="loginUser?.userRole == 'FRACTAL_ADMIN'"
        (click)="navToReportedQuestion()"
      >
        <img
          [src]="_commonServices.Images.QUESTION_REPORT"
          alt="report"
          class="cursor-pointer w-8 h-8"
        />
      </div>

      <div
        *ngIf="this.loginUser?.userRole == 'FRACTAL_HR' && !isStaffingDomain"
      >
        <img
          (click)="routeToWorkdayFailures()"
          [src]="_commonServices.Images.EXCLAMATION_MARK"
          alt="alert"
          class="-mt-[0.1rem] w-8 h-8 cursor-pointer"
        />
      </div>

      <div>
        <img
          *ngIf="!isStaffingDomain"
          [src]="_commonServices.Images.NOTIFICATION_ICON"
          alt="notification"
          class="my-auto"
        />
      </div>

      <div
        class="profile-dropdown"
        appOutsideClick
        (appOutsideClick)="closeDropdown()"
        (keydown.escape)="closeDropdown(); profileTrigger.focus()"
      >
        <button
          type="button"
          class="profile-trigger"
          (click)="togglePopup()"
          [attr.aria-expanded]="isOpen"
          aria-controls="header-profile-dropdown"
          aria-label="Account options"
          #dropdownElement
          #profileTrigger
        >
          <img
            *ngIf="loginUser?.userRole == 'CANDIDATE'; else profileInitials"
            [src]="profileImageUrl || _commonServices.Images.AVATAR"
            alt="avatar"
            class="profile-avatar profile-avatar-photo"
          />
          <ng-template #profileInitials>
            <span class="profile-avatar" aria-hidden="true">
              {{ (getUsernameInitials(loginUser?.fullName) | slice: 0 : 2) || 'NA' }}
            </span>
          </ng-template>
          <span class="profile-trigger-details">
            <span class="profile-trigger-heading">
              <span class="profile-trigger-name" [title]="loginUser?.fullName || 'N/A'">
                {{ loginUser?.fullName?.trim()?.split(' ')[0] || 'N/A' }}
              </span>
              <svg class="profile-chevron" [class.profile-chevron-open]="isOpen" width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true">
                <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="profile-trigger-role poppinsMedium">
              {{
                loginUser?.userRole === "FRACTAL_ADMIN"
                  ? "Admin"
                  : loginUser?.userRole === "COLLEGE_ADMIN"
                    ? "College Admin"
                    : loginUser?.userRole === "FRACTAL_HR" && !isStaffingDomain
                      ? "Hr"
                      : isStaffingDomain
                        ? loginUser?.userRole === "VISITOR"
                          ? "Visitor"
                          : loginUser?.isPmViewEnabled
                            ? "PM"
                            : "Staffing"
                        : "N/A"
              }}
            </span>
          </span>
        </button>

        <div *ngIf="isOpen" id="header-profile-dropdown" class="profile-menu">
          <button type="button" class="profile-menu-identity !cursor-text" (click)="togglePopup()" aria-label="Close account options">
            <span class="profile-avatar profile-avatar-small" aria-hidden="true">
              {{ (getUsernameInitials(loginUser?.fullName) | slice: 0 : 2) || 'NA' }}
            </span>
            <span class="profile-menu-details">
              <span class="profile-menu-name poppinsSemibold" [title]="loginUser?.fullName || 'N/A'">
                {{ loginUser?.fullName || 'N/A' }}
              </span>
              <p class="profile-menu-email text-xs poppinsRegular text-my_profile_secondary_text" [title]="loginUser?.email || ''">{{ loginUser?.email }}</p>
            </span>
          </button>
          <ul class="profile-menu-actions">
            <li *ngIf="loginUser?.userRole != 'COLLEGE_ADMIN'">
              <button type="button" class="profile-menu-action poppinsMedium text-my_profile_secondary_text  hover:text-primary_Text_Color" (click)="openChangePasswordPopup(); closeDropdown()">
                <svg width="14" height="14"  viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.68907 4.69182V3.18983C2.68907 2.52591 2.95279 1.88919 3.42222 1.41973C3.89164 0.950264 4.52832 0.686523 5.19218 0.686523C5.85605 0.686523 6.49272 0.950264 6.96215 1.41973C7.43157 1.88919 7.69529 2.52591 7.69529 3.18983V4.69182M5.6928 7.69579C5.6928 7.9723 5.46867 8.19645 5.19218 8.19645C4.9157 8.19645 4.69156 7.9723 4.69156 7.69579C4.69156 7.41928 4.9157 7.19513 5.19218 7.19513C5.46867 7.19513 5.6928 7.41928 5.6928 7.69579ZM1.68783 4.69182H8.69654C9.24951 4.69182 9.69778 5.14013 9.69778 5.69314V9.69844C9.69778 10.2515 9.24951 10.6998 8.69654 10.6998H1.68783C1.13486 10.6998 0.686584 10.2515 0.686584 9.69844V5.69314C0.686584 5.14013 1.13486 4.69182 1.68783 4.69182Z" stroke="currentColor" stroke-width="1.37313" stroke-linecap="round"/>
                </svg>
                <span>Change Password</span>
              </button>
            </li>
            <li>
              <button type="button" class="profile-menu-action poppinsMedium text-my_profile_secondary_text  hover:text-primary_Text_Color" (click)="logOut(); closeDropdown()">
                <svg width="14" height="14"  viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.19467 2.68901L9.69778 5.19212L7.19467 7.69523M9.69778 5.19212H3.69032M3.69032 9.69772H1.68783C1.42228 9.69772 1.16761 9.59223 0.979842 9.40446C0.792072 9.21669 0.686584 8.96202 0.686584 8.69647V1.68777C0.686584 1.42222 0.792072 1.16755 0.979842 0.979781C1.16761 0.792011 1.42228 0.686523 1.68783 0.686523H3.69032" stroke="currentColor" stroke-width="1.37313" stroke-linecap="round"/>
                </svg>

                <span>Sign Out</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</header>

<!-- Sidebar -->
<div
  class="fixed inset-0 z-50 bg-black/60 backdrop-blur-[2px] transition-opacity duration-200 ease-out"
  [class.opacity-100]="isSidebarOpen"
  [class.opacity-0]="!isSidebarOpen"
  [class.pointer-events-none]="!isSidebarOpen"
  (click)="closeSidebar()"
  aria-hidden="true"
></div>

<!-- Panel -->
<aside
  class="fixed left-0 top-0 z-[60] h-svh w-[250px] bg-white shadow-2xl border-r border-black/5 transition-transform duration-300 ease-out will-change-transform flex flex-col text-sm"
  [class.-translate-x-full]="!isSidebarOpen"
  [class.translate-x-0]="isSidebarOpen"
  role="dialog"
  aria-modal="true"
  aria-label="Main navigation"
>
  <div class="flex items-center justify-end px-4 py-3">
    <button
      type="button"
      class="grid place-items-center size-8 rounded-full hover:bg-gray-100 transition"
      (click)="closeSidebar()"
      aria-label="Close menu"
    >
      <img [src]="_commonServices.Images.CLOSE_SEARCH" alt="Close menu" />
    </button>
  </div>

  <hr class="border-gray-100" />

  <!-- Nav items -->
  <nav class="flex-1 overflow-y-auto px-4 mt-4">
    <ul class="space-y-2">
      <!-- Home -->
      <li *ngIf="loginUser && !loginUser.isPmViewEnabled">
        <a
          (click)="
            navigateAndClose(
              isStaffingDomain ? '/staffing/staffing-landing' : '/home',
              'home'
            )
          "
          class="group  text-sm  relative flex items-center gap-2 pr-3 py-3 rounded-lg poppinsMedium transition-colors duration-200 cursor-pointer"
          [ngClass]="{
            'bg-[#DFE5F5] text-primary_Bg_Button_Color': selectedMenu === 'home',
            'text-inactive_status_text hover:bg-hovered_side_bar hover:text-primary_Text_Color': selectedMenu !== 'home'
          }"
        >
          <span
            class="pointer-events-none absolute left-0 top-1/2  h-5 w-[3px] rounded-r-md bg-primary_Bg_Button_Color transition-opacity duration-200"
            [ngClass]="{
              'opacity-100': selectedMenu === 'home',
              'opacity-0': selectedMenu !== 'home'
            }"
          ></span>

          <span class="relative ml-[6px] inline-block size-5 shrink-0">
            <img
              *ngIf="selectedMenu !== 'home'"
              [src]="_commonServices.Images.HOME_DEFAULT"
              class="size-5 block group-hover:hidden"
            />
            <img
              *ngIf="selectedMenu !== 'home'"
              [src]="_commonServices.Images.HOME_HOVER_STATE"
              class="size-5 hidden group-hover:block"
            />
            <img
              *ngIf="selectedMenu === 'home'"
              [src]="_commonServices.Images.HOME_ACTIVE"
              class="size-5"
            />
          </span>

          <span>Home</span>
        </a>
      </li>

      <!-- AI Matching -->
      <li *ngIf="loginUser && !loginUser.isPmViewEnabled">
        <a
          (click)="
            navigateAndClose(
              isStaffingDomain ? '/staffing/ai-matching' : '/ai-matching',
              'aiMatching'
            )
          "
          class="group text-sm  relative flex items-center gap-2 pr-3 py-3 rounded-lg poppinsMedium transition-colors duration-200 cursor-pointer"
          [ngClass]="{
            'bg-[#DFE5F5] text-primary_Bg_Button_Color': selectedMenu === 'aiMatching',
            'text-inactive_status_text hover:bg-hovered_side_bar hover:text-primary_Text_Color': selectedMenu !== 'aiMatching'
          }"
        >
          <span
            class="pointer-events-none absolute left-0 top-1/2  h-5 w-[3px] rounded-r-md bg-primary_Bg_Button_Color transition-opacity duration-200"
            [ngClass]="{
              'opacity-100': selectedMenu === 'aiMatching',
              'opacity-0': selectedMenu !== 'aiMatching'
            }"
          ></span>

          <span class="relative ml-[6px] inline-block size-5 shrink-0">
            <img
              *ngIf="selectedMenu !== 'aiMatching'"
              [src]="_commonServices.Images.PROFILE_DEFAULT"
              class="size-6 block group-hover:hidden"
            />
            <img
              *ngIf="selectedMenu !== 'aiMatching'"
              [src]="_commonServices.Images.PROFILE_HOVER_STATE"
              class="size-6 hidden group-hover:block"
            />
            <img
              *ngIf="selectedMenu === 'aiMatching'"
              [src]="_commonServices.Images.PROFILE_ACTIVE"
              class="size-6"
            />
          </span>

          <span>AI Matching</span>
        </a>
      </li>

          <!-- Demand tracker -->
      <li>
        <a
          (click)="navigateAndClose('/staffing/demand-tracker', 'tracker')"
          class="group text-sm  relative flex items-center gap-2 pr-3 py-3 rounded-lg poppinsMedium transition-colors duration-200 cursor-pointer"
          [ngClass]="{
            'bg-[#DFE5F5] text-primary_Bg_Button_Color': selectedMenu === 'tracker',
            'text-inactive_status_text hover:bg-hovered_side_bar hover:text-primary_Text_Color': selectedMenu !== 'tracker'
          }"
        >
          <span
            class="pointer-events-none absolute left-0 top-1/2  h-5 w-[3px] rounded-r-md bg-primary_Bg_Button_Color transition-opacity duration-200"
            [ngClass]="{
              'opacity-100': selectedMenu === 'tracker',
              'opacity-0': selectedMenu !== 'tracker'
            }"
          ></span>

          <span class="relative inline-block ml-[6px] size-5 shrink-0">
            <img
              *ngIf="selectedMenu !== 'tracker'"
              [src]="_commonServices.Images.TRACKER_DEFAULT"
              class="size-6 block group-hover:hidden"
            />
            <img
              *ngIf="selectedMenu !== 'tracker'"
              [src]="_commonServices.Images.TRACKER_HOVER_STATE"
              class="size-6 hidden group-hover:block"
            />
            <img
              *ngIf="selectedMenu === 'tracker'"
              [src]="_commonServices.Images.TRACKER_ACTIVE"
              class="size-6"
            />
          </span>

          <span class="mt-1">Tracker</span>
        </a>
      </li>

      <!-- Data Upload -->
      <li *ngIf="loginUser && !loginUser.isPmViewEnabled">
        <a
          (click)="navigateAndClose('/staffing/import-data', 'upload')"
          class="group text-sm  relative flex items-center gap-2 pr-3 py-3 rounded-lg poppinsMedium transition-colors duration-200 cursor-pointer"
          [ngClass]="{
            'bg-[#DFE5F5] text-primary_Bg_Button_Color': selectedMenu === 'upload',
            'text-inactive_status_text hover:bg-hovered_side_bar hover:text-primary_Text_Color': selectedMenu !== 'upload'
          }"
        >
          <span
            class="pointer-events-none absolute left-0 top-1/2  h-5 w-[3px] rounded-r-md bg-primary_Bg_Button_Color transition-opacity duration-200"
            [ngClass]="{
              'opacity-100': selectedMenu === 'upload',
              'opacity-0': selectedMenu !== 'upload'
            }"
          ></span>

          <span class="relative ml-[6px] inline-block size-5 shrink-0">
            <img
              *ngIf="selectedMenu !== 'upload'"
              [src]="_commonServices.Images.DOCUMENT_UPLOAD_DEFAULT"
              class="size-6 block group-hover:hidden"
            />
            <img
              *ngIf="selectedMenu !== 'upload'"
              [src]="_commonServices.Images.DOCUMENT_UPLOAD_HOVER_STATE"
              class="size-6 hidden group-hover:block"
            />
            <img
              *ngIf="selectedMenu === 'upload'"
              [src]="_commonServices.Images.DOCUMENT_UPLOAD_ACTIVE"
              class="size-6"
            />
          </span>

          <span>Data Upload</span>
        </a>
      </li>

      <!-- PM View -->
      <li>
        <a
          (click)="navigateAndClose('/staffing/ai-matching', 'pmView')"
          class="group text-sm  relative flex items-center gap-2 pr-3 py-3 rounded-lg poppinsMedium transition-colors duration-200 cursor-pointer"
          [ngClass]="{
             'bg-[#DFE5F5] text-primary_Bg_Button_Color': selectedMenu === 'pmView',
             'text-inactive_status_text hover:bg-hovered_side_bar hover:text-primary_Text_Color': selectedMenu !== 'pmView'
          }"
        >
          <span
            class="pointer-events-none absolute left-0 top-1/2  h-5 w-[3px] rounded-r-md bg-primary_Bg_Button_Color transition-opacity duration-200"
            [ngClass]="{
              'opacity-100': selectedMenu === 'pmView',
              'opacity-0': selectedMenu !== 'pmView'
            }"
          ></span>

          <span class="relative ml-[6px] inline-block size-5 shrink-0">
            <img
              *ngIf="selectedMenu !== 'pmView'"
              [src]="_commonServices.Images.PROFILE_DEFAULT"
              class="size-6 block group-hover:hidden"
            />
            <img
              *ngIf="selectedMenu !== 'pmView'"
              [src]="_commonServices.Images.PROFILE_HOVER_STATE"
              class="size-6 hidden group-hover:block"
            />
            <img
              *ngIf="selectedMenu === 'pmView'"
              [src]="_commonServices.Images.PROFILE_ACTIVE"
              class="size-6"
            />
          </span>

          <span>PM view</span>
        </a>
      </li>

      <!-- Drives -->
      <li *ngIf="loginUser && !loginUser.isPmViewEnabled">
        <a
          (click)="navigateAndClose('/drives', 'drives')"
          class="group text-sm  relative flex items-center gap-2 pr-3 py-3 rounded-lg poppinsMedium transition-colors duration-200 cursor-pointer"
          [ngClass]="{
            'bg-[#DFE5F5] text-primary_Bg_Button_Color': selectedMenu === 'drives',
            'text-inactive_status_text hover:bg-hovered_side_bar hover:text-primary_Text_Color': selectedMenu !== 'drives'
          }"
        >
          <span
            class="pointer-events-none absolute left-0 top-1/2  h-5 w-[3px] rounded-r-md bg-primary_Bg_Button_Color transition-opacity duration-200"
            [ngClass]="{
              'opacity-100': selectedMenu === 'drives',
              'opacity-0': selectedMenu !== 'drives'
            }"
          ></span>

          <span class="relative inline-block ml-[6px] size-5 shrink-0">
            <img
              *ngIf="selectedMenu !== 'drives'"
              [src]="_commonServices.Images.DRIVES_DEFAULT"
              class="size-6 block group-hover:hidden"
            />
            <img
              *ngIf="selectedMenu !== 'drives'"
              [src]="_commonServices.Images.DRIVES_HOVER_STATE"
              class="size-6 hidden group-hover:block"
            />
            <img
              *ngIf="selectedMenu === 'drives'"
              [src]="_commonServices.Images.DRIVES_ACTIVE"
              class="size-6"
            />
          </span>

          <span>Drives</span>
        </a>
      </li>
  
    </ul>
  </nav>
</aside>
